import Cookies from 'js-cookie'

import { CONSENT_COOKIE } from '../consent/config'
import { notInBrowser } from '../environment'
import { Scripts } from './scripts'
import { SDKScripts } from '../generated/types'

class BrowserScripts extends Scripts {
  hasConsent(script: SDKScripts) {
    if (notInBrowser()) {
      return false
    }

    const category = this.getScriptCategory(script)
    if (!category) {
      return false
    }

    const consentCookie = Cookies.get(CONSENT_COOKIE)
    if (!consentCookie) {
      return false
    }

    const consents = JSON.parse(consentCookie).categories as string[]

    return consents.includes(category)
  }
}

export const browserScripts = new BrowserScripts()
